import { render, staticRenderFns } from "./StudentDetailCard.vue?vue&type=template&id=147acf78&scoped=true&"
import script from "./StudentDetailCard.vue?vue&type=script&lang=js&"
export * from "./StudentDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./StudentDetailCard.vue?vue&type=style&index=0&id=147acf78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147acf78",
  null
  
)

export default component.exports